module.exports = __webpack_public_path__ + "img/234.53e1a3e6.jpg";